<template>
  <div id="pagenation-area" class="flex items-cenetr justify-between py-4 px-2">
    
    <!-- 件数変更 -->
    <vs-dropdown
      vs-trigger-click
      class="cursor-pointer"
      :color="AISEA_COLOR.BLUE"
    >
      <div
        class="
          p-3
          border border-solid
          d-theme-border-grey-light
          rounded-full
          cursor-pointer
          flex
          items-center
          justify-between
        "
      >
        <span class="mr-2 aisea-text-12-400-black sm:w-16 md:w-24" >
          {{ startTaskNum }}-{{ endTaskNum }} / {{ totalTaskCount }}
        </span>
        <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
      </div>
      <vs-dropdown-menu>
        <vs-dropdown-item @click="onChangePageSize(25)">
          <span>25</span>
        </vs-dropdown-item>
        <vs-dropdown-item @click="onChangePageSize(50)">
          <span>50</span>
        </vs-dropdown-item>
        <vs-dropdown-item @click="onChangePageSize(75)">
          <span>75</span>
        </vs-dropdown-item>
        <vs-dropdown-item @click="onChangePageSize(100)">
          <span>100</span>
        </vs-dropdown-item>
      </vs-dropdown-menu>
    </vs-dropdown>

    <!-- ページ変更 -->
    <vs-pagination
      :total="totalPages"
      :color="AISEA_COLOR.BLUE"
      :max="maxPaginationCount"
      v-model="currentPage"
      class="ml-2"
    ></vs-pagination>
  </div>
</template>

<script>
import { DeviceInfoMixin, ColorMixin } from "@/mixins";
import { createNamespacedHelpers } from "vuex";

const { mapActions, mapGetters, mapMutations, mapState } = createNamespacedHelpers("enterpriseBackgroundTaskManager");

export default {
  mixins: [DeviceInfoMixin, ColorMixin],
  data () {
    return {
      // currentPage: 1,
    }
  },
  computed: {
    ...mapState(["tasks", "totalTaskCount", "taskPageSize", "currentTaskPage"]),
    ...mapGetters(["displayLocalTaskCount", "startTaskNum", "endTaskNum" ]),
    currentPage:{
      get(){
        return this.currentTaskPage;
      },
      set(val) {
        this.SET_CURRENT_TASK_PAGE(val);
      }
    },
    totalPages () {
      const page = Math.ceil(this.totalTaskCount / this.taskPageSize);
      return page;
    },
    maxPaginationCount() {
        return 7;
      }
  },
  watch:{
    currentPage() {
      this.fetchAllTaskList()
    }
  },
  methods: {
    ...mapActions(["fetchAllTaskList", "fetchTaskCount", "_startUploadTask"]),
    ...mapMutations(["SET_TASK_PAGE_SIZE", "SET_CURRENT_TASK_PAGE"]),

    onChangePageSize (count) {
      this.currentPage = 1;
      this.SET_TASK_PAGE_SIZE(count);
      this.fetchAllTaskList()
    },

  },
  mounted(){

    
  }
}
</script>

<style>
</style>